/* ============================================================
   PILLAR QUIZ PORTE-ENCENS — Quel porte-encens est fait pour vous ?
   4 questions · scoring 5 issues (PB/BC/EE/FC/KT)
   ============================================================ */

(function () {
  'use strict';

  var ICONS = {
    pb: '<svg viewBox="0 0 40 44" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><line x1="20" y1="34" x2="20" y2="10"/><circle cx="20" cy="8" r="1.4" fill="currentColor" stroke="none"/><path d="M20 5 Q 17 3, 19 1" opacity="0.55"/><path d="M10 34 L 30 34 L 28 38 L 12 38 Z"/></svg>',
    bc: '<svg viewBox="0 0 40 44" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M8 28 Q 8 22, 14 21 L 26 21 Q 32 22, 32 28 L 32 33 Q 32 38, 27 38 L 13 38 Q 8 38, 8 33 Z"/><path d="M14 21 Q 14 18, 20 17 Q 26 18, 26 21"/><path d="M18 17 Q 16 13, 19 9" opacity="0.55"/><path d="M22 17 Q 24 13, 21 9" opacity="0.55"/></svg>',
    ee: '<svg viewBox="0 0 40 44" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="12" width="22" height="20" rx="3"/><circle cx="20" cy="22" r="4"/><circle cx="20" cy="22" r="1.4" fill="currentColor" stroke="none"/><line x1="14" y1="36" x2="14" y2="40"/><line x1="26" y1="36" x2="26" y2="40"/><line x1="12" y1="40" x2="28" y2="40"/><path d="M14 8 Q 13 5, 16 4" opacity="0.55"/><path d="M26 8 Q 27 5, 24 4" opacity="0.55"/></svg>',
    fc: '<svg viewBox="0 0 40 50" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18 L 20 4 L 26 18 Z"/><circle cx="20" cy="2.5" r="1.2" fill="currentColor" stroke="none"/><line x1="12" y1="20" x2="28" y2="20"/><path d="M16 24 Q 14 30, 17 36 Q 19 41, 14 46"/><path d="M24 24 Q 26 30, 23 36 Q 21 41, 26 46"/><line x1="10" y1="48" x2="30" y2="48"/></svg>',
    kt: '<svg viewBox="0 0 40 44" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="13" cy="14" r="4"/><circle cx="27" cy="14" r="4"/><rect x="10" y="24" width="20" height="11" rx="2"/><line x1="14" y1="28" x2="26" y2="28"/><line x1="8" y1="37" x2="32" y2="37"/></svg>'
  };

  var QUIZ_DATA = window.QUIZ_DATA_PE;

  function initQuiz(root) {
    var engine = root.querySelector('[data-pq-engine]');
    if (!engine) return;

    var stateIntro = engine.querySelector('[data-pq-state="intro"]');
    var stateQuestion = engine.querySelector('[data-pq-state="question"]');
    var stateResult = engine.querySelector('[data-pq-state="result"]');
    var startBtn = engine.querySelector('[data-pq-start]');
    var backBtn = engine.querySelector('[data-pq-back]');
    var restartBtn = engine.querySelector('[data-pq-restart]');
    var qTitle = engine.querySelector('[data-pq-question]');
    var qOptions = engine.querySelector('[data-pq-options]');
    var pCurrent = engine.querySelector('[data-pq-progress-current]');
    var pTotal = engine.querySelector('[data-pq-progress-total]');
    var pFill = engine.querySelector('[data-pq-progress-fill]');
    var rIcon = engine.querySelector('[data-pq-result-icon]');
    var rTitle = engine.querySelector('[data-pq-result-title]');
    var rText = engine.querySelector('[data-pq-result-text]');
    var rMain = engine.querySelector('[data-pq-result-cta-main]');
    var rMainLabel = engine.querySelector('[data-pq-result-cta-main-label]');
    var rUpsell = engine.querySelector('[data-pq-result-cta-upsell]');
    var rUpsellLabel = engine.querySelector('[data-pq-result-cta-upsell-label]');

    var state = {
      qIndex: 0,
      scores: { pb: 0, bc: 0, ee: 0, fc: 0, kt: 0 },
      history: []
    };

    pTotal.textContent = QUIZ_DATA.questions.length;

    function show(stateEl) {
      [stateIntro, stateQuestion, stateResult].forEach(function (s) { s.hidden = (s !== stateEl); });
      stateEl.classList.remove('is-fading-in');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          stateEl.classList.add('is-fading-in');
        });
      });
    }

    function scrollIntoView() {
      var rect = root.getBoundingClientRect();
      var stickyHeader = document.querySelector('sticky-header');
      var headerOffset = stickyHeader ? stickyHeader.offsetHeight + 16 : 80;
      if (rect.top < headerOffset || rect.top > window.innerHeight * 0.4) {
        var targetY = rect.top + window.pageYOffset - headerOffset;
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      }
    }

    function renderQuestion() {
      var q = QUIZ_DATA.questions[state.qIndex];
      qTitle.textContent = q.text;
      pCurrent.textContent = (state.qIndex + 1);
      var pct = ((state.qIndex + 1) / QUIZ_DATA.questions.length) * 100;
      pFill.style.width = pct + '%';
      qOptions.innerHTML = '';
      q.options.forEach(function (opt, idx) {
        var li = document.createElement('li');
        li.className = 'pq-options__item';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pq-option';
        btn.innerHTML = '<span class="pq-option__dot" aria-hidden="true"></span><span class="pq-option__label">' + opt.label + '</span>';
        btn.addEventListener('click', function () { onAnswer(idx); });
        li.appendChild(btn);
        qOptions.appendChild(li);
      });
      backBtn.hidden = (state.qIndex === 0);
      show(stateQuestion);
    }

    function onAnswer(optIdx) {
      var q = QUIZ_DATA.questions[state.qIndex];
      var opt = q.options[optIdx];
      state.history.push({ qIndex: state.qIndex, scores: Object.assign({}, opt.scores) });
      Object.keys(opt.scores).forEach(function (k) {
        state.scores[k] = (state.scores[k] || 0) + opt.scores[k];
      });
      if (state.qIndex < QUIZ_DATA.questions.length - 1) {
        state.qIndex++;
        renderQuestion();
      } else {
        renderResult();
      }
    }

    function onBack() {
      if (state.qIndex === 0 || state.history.length === 0) return;
      var last = state.history.pop();
      Object.keys(last.scores).forEach(function (k) {
        state.scores[k] = (state.scores[k] || 0) - last.scores[k];
      });
      state.qIndex--;
      renderQuestion();
    }

    function pickWinner() {
      var keys = Object.keys(state.scores);
      var winner = keys[0];
      var max = -Infinity;
      keys.forEach(function (k) {
        if (state.scores[k] > max) { max = state.scores[k]; winner = k; }
      });
      return winner;
    }

    function renderResult() {
      var winner = pickWinner();
      var r = QUIZ_DATA.results[winner];
      if (rIcon) {
        rIcon.innerHTML = ICONS[winner] || '';
        rIcon.setAttribute('data-pq-icon-key', winner);
      }
      rTitle.textContent = r.title;
      rText.textContent = r.text;
      rMainLabel.textContent = r.ctaMain.label;
      rMain.setAttribute('href', r.ctaMain.url);
      rUpsellLabel.textContent = r.ctaUpsell.label;
      rUpsell.setAttribute('href', r.ctaUpsell.url);
      try {
        if (window.dataLayer) {
          window.dataLayer.push({ event: 'pillar_quiz_porte_encens_result', quiz_winner: winner });
        }
        if (window.gtag) { window.gtag('event', 'pillar_quiz_porte_encens_result', { quiz_winner: winner }); }
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish('pillar_quiz_porte_encens_result', { quiz_winner: winner });
        }
      } catch (e) {}
      show(stateResult);
    }

    function onRestart() {
      state.qIndex = 0;
      state.scores = { pb: 0, bc: 0, ee: 0, fc: 0, kt: 0 };
      state.history = [];
      show(stateIntro);
      scrollIntoView();
    }

    startBtn.addEventListener('click', function () {
      try {
        if (window.dataLayer) window.dataLayer.push({ event: 'pillar_quiz_porte_encens_start' });
        if (window.gtag) window.gtag('event', 'pillar_quiz_porte_encens_start');
      } catch (e) {}
      renderQuestion();
      scrollIntoView();
    });

    backBtn.addEventListener('click', onBack);
    restartBtn.addEventListener('click', onRestart);

    show(stateIntro);
  }

  function bootAll() {
    document.querySelectorAll('.pq-section--porte-encens').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
